import React from "react";
import type {NavigationTabsModuleTabModel} from "../models/tabs/navigation-tabs-module.tab-model";
import {NAVIGATION_TABS} from "../navigation-tabs-module.consts";
import classNames from "classnames";
import styles from "../styles/navigation-tabs.module.scss";
import {Loader} from "../../../core/components/loading/loader";

export const NavigationTabsModuleComposer = (Widget) => (({
                                                            controller,
                                                            onTabChange,
                                                            currentIndex,
                                                            entity,
                                                            supportArrows,
                                                            className,
                                                            tabClassName,
                                                            isLoading
                                                          }) => {

  const {state, device} = controller;
  const {isSmallView} = device;
  const {entityContext} = state;

  const onTabClick = (tab: NavigationTabsModuleTabModel, direction) => {
    const currentTab: NavigationTabsModuleTabModel = !tab && direction ? getTabByDirection(direction) : tab;
    onTabChange?.(currentTab.index);

    currentTab.eventName && controller.action(currentTab.eventName, currentTab.eventParams);
    controller.action(NAVIGATION_TABS.ACTION_TYPES.tabClick, {
      entityId: currentTab.analyticsEntityId,
      entityType: currentTab.analyticsEntityType,
      tabName: currentTab.analyticsName,
      status: currentTab.status
    });

    return !currentIndex || currentIndex < 0;
  }

  const getTabByDirection = (direction): NavigationTabsModuleTabModel => {
    let index: Number = entityContext.activeTab.index;
    const tabsLength: Number = entityContext.tabs.length;

    const activeTabIndex: NavigationTabsModuleTabModel = entityContext.tabs.findIndex(tab => tab.index === index);

    if (direction === NAVIGATION_TABS.DIRECTIONS.prev) {
      index = activeTabIndex === 0 ? entityContext.tabs.last().index : entityContext.tabs[activeTabIndex - 1].index;
    } else if (direction === NAVIGATION_TABS.DIRECTIONS.next) {
      index = activeTabIndex === tabsLength - 1 ? entityContext.tabs.first().index : entityContext.tabs[activeTabIndex + 1].index;
    }

    const tab: NavigationTabsModuleTabModel = entityContext.tabs.find(tab => tab.index === index);

    return tab;
  }

  const newProps = {
    onTabClick,
    controller,
    currentIndex,
    entity,
    supportArrows,
    className,
    tabClassName
  };

  const loaderProps = {
    when: isLoading,
    Component: () => <div className={classNames(styles.container, {[styles.small_view]: isSmallView})}/>
  }

  return <Loader {...loaderProps} ><Widget {...newProps}/></Loader>;
});
